import { CAMCFundFOFHandler } from "_fil_local_addon/camc-fund-detail-app/camc-fund-detail-app";
import CAMCFundFees from "./camc-fund-fees";

class WebsiteCAMCFundFee extends CAMCFundFees {
    constructor(fundCode) {
        super(fundCode);
        this.$feesDesc = $(".fund-fees .fund-fees__description");
        this.$root = $(".fund-fees");
    }

    errorHandler() {
        showApiMessageing($(".fund-fees"));
    }

    renderPensionHeader(headerContext) {
        return `
            <td class="charges-pension-header" colspan="2" bgcolor="#B9BDC4" style="padding-top:10px;padding-bottom:10px;font-weight:700;">
                ${headerContext}
            </td>
        `;
    }

    renderFeesDescription(descriptionContext) {
        if (descriptionContext) {
            const $container = $(".fund-fees .fund-redemption-fees-description");
            $container.append(`<p><b>${descriptionContext}</b></p>`);
        }
    }

    renderSubscriptionRate(feesData) {
        if (feesData.subscriptionRate != null) {
            let charges_table_item = "";
            let pensionList = [];
            let noPensionList = [];
            for (let i = 0; i < feesData.subscriptionRate.length; i++) {
                let item = null;
                item = feesData.subscriptionRate[i];
                let isPension = item.isPension;
                if (isPension == "N") {
                    noPensionList.push(item);
                } else {
                    pensionList.push(item);
                }
            }
            if (noPensionList.length > 0) {
                for (let j = 0; j < noPensionList.length; j++) {
                    let item = noPensionList[j];
                    if (j < noPensionList.length - 1) {
                        $(".subscriptionRate .t-item").last().clone().appendTo(".subscriptionRate .table-wrapper");
                    }

                    if (item.chargeTierTo == null) {
                        charges_table_item = "认购金额 ≥ " + Math.floor(item.chargeTierFrom / 10000) + "万元";
                    } else if (item.chargeTierFrom == 0) {
                        charges_table_item = "认购金额 < " + Math.floor(item.chargeTierTo / 10000) + "万元";
                    } else {
                        let chargeTierFrom = Math.floor(item.chargeTierFrom / 10000);
                        let chargeTierTo = Math.floor(item.chargeTierTo / 10000);
                        if (chargeTierFrom == 0) {
                            charges_table_item = "认购金额 < " + chargeTierTo + "万元";
                        } else {
                            charges_table_item = chargeTierFrom + "万元 ≤ 认购金额 < " + chargeTierTo + "万元";
                        }
                    }
                    if (item.chargeTierTo == null) {
                        $(".subscriptionRate .charge-rate")
                            .eq(j)
                            .html("每笔" + this.milliFormat(item.chargeRatio) + "元");
                    } else {
                        $(".subscriptionRate .charge-rate")
                            .eq(j)
                            .html(this.formatFeesValue(item.chargeRatio) + "%");
                    }
                    $(".subscriptionRate .charges-table-item").eq(j).html(charges_table_item);
                }
            }

            if (pensionList.length > 0) {
                $(".subscriptionRate .t-item")
                    .last()
                    .clone()
                    .addClass("pension-item")
                    .appendTo(".subscriptionRate .table-wrapper");
                if (noPensionList.length == 0) {
                    $(".subscriptionRate .table-wrapper").find("tr:first").remove();
                }
                for (let j = 0; j < pensionList.length; j++) {
                    if (j < pensionList.length) {
                        $(".subscriptionRate .t-item")
                            .last()
                            .clone()
                            .removeClass("pension-item")
                            .appendTo(".subscriptionRate .table-wrapper");
                    }
                    let pensionLength = noPensionList.length + 1 + j;

                    let item = pensionList[j];

                    if (item.chargeTierTo == null && item.chargeTierFrom == null) {
                        charges_table_item = "任意认购金额";
                    } else if (item.chargeTierTo == null) {
                        charges_table_item = "认购金额 ≥ " + Math.floor(item.chargeTierFrom / 10000) + "万元";
                    } else if (item.chargeTierFrom == 0) {
                        charges_table_item = "认购金额 < " + Math.floor(item.chargeTierTo / 10000) + "万元";
                    } else {
                        let chargeTierFrom = Math.floor(item.chargeTierFrom / 10000);
                        let chargeTierTo = Math.floor(item.chargeTierTo / 10000);
                        if (chargeTierFrom == 0) {
                            charges_table_item = "认购金额 < " + chargeTierTo + "万元";
                        } else {
                            charges_table_item = chargeTierFrom + "万元 ≤ 认购金额 < " + chargeTierTo + "万元";
                        }
                    }
                    if (item.chargeTierTo == null) {
                        $(".subscriptionRate .charge-rate")
                            .eq(pensionLength)
                            .html("每笔" + this.milliFormat(item.chargeRatio) + "元");
                    } else {
                        $(".subscriptionRate .charge-rate")
                            .eq(pensionLength)
                            .html(this.formatFeesValue(item.chargeRatio) + "%");
                    }
                    $(".subscriptionRate .charges-table-item").eq(pensionLength).html(charges_table_item);
                }
            }

            $(".subscriptionRate .pension-item")
                .empty()
                .append(this.renderPensionHeader("通过直销中心认购的养老金客户"));
            $(".subscriptionRate").removeClass("invisible");
        } else {
            $(".subscriptionRate").remove();
        }
    }

    renderPurchasingRate(feesData) {
        if (feesData.purchasingRate != null) {
            let charges_table_item = "";
            let pensionList = [];
            let noPensionList = [];
            for (let i = 0; i < feesData.purchasingRate.length; i++) {
                let item = null;
                item = feesData.purchasingRate[i];
                let isPension = item.isPension;
                if (isPension == "N") {
                    noPensionList.push(item);
                } else {
                    pensionList.push(item);
                }
            }
            if (noPensionList.length > 0) {
                for (let j = 0; j < noPensionList.length; j++) {
                    let item = noPensionList[j];
                    if (j < noPensionList.length - 1) {
                        $(".purchasingRate .t-item").last().clone().appendTo(".purchasingRate .table-wrapper");
                    }
                    if (item.chargeTierTo == null) {
                        charges_table_item = "申购金额 ≥ " + Math.floor(item.chargeTierFrom / 10000) + "万元";
                    } else if (item.chargeTierFrom == 0) {
                        charges_table_item = "申购金额 < " + Math.floor(item.chargeTierTo / 10000) + "万元";
                    } else {
                        let chargeTierFrom = Math.floor(item.chargeTierFrom / 10000);
                        let chargeTierTo = Math.floor(item.chargeTierTo / 10000);
                        if (chargeTierFrom == 0) {
                            charges_table_item = "申购金额 < " + chargeTierTo + "万元";
                        } else {
                            charges_table_item = chargeTierFrom + "万元 ≤ 申购金额 < " + chargeTierTo + "万元";
                        }
                    }
                    if (item.chargeTierTo == null) {
                        $(".purchasingRate .charge-rate")
                            .eq(j)
                            .html("每笔" + this.milliFormat(item.chargeRatio) + "元");
                    } else {
                        $(".purchasingRate .charge-rate")
                            .eq(j)
                            .html(this.formatFeesValue(item.chargeRatio) + "%");
                    }
                    $(".purchasingRate .charges-table-item").eq(j).html(charges_table_item);
                }
            }

            if (pensionList.length > 0) {
                $(".purchasingRate .t-item")
                    .last()
                    .clone()
                    .addClass("pension-item")
                    .appendTo(".purchasingRate .table-wrapper");
                if (noPensionList.length == 0) {
                    $(".purchasingRate .table-wrapper").find("tr:first").remove();
                }
                for (let j = 0; j < pensionList.length; j++) {
                    let item = pensionList[j];
                    if (j < pensionList.length) {
                        $(".purchasingRate .t-item")
                            .last()
                            .clone()
                            .removeClass("pension-item")
                            .appendTo(".purchasingRate .table-wrapper");
                    }
                    let pensionLength = noPensionList.length + 1 + j;

                    if (item.chargeTierTo == null && item.chargeTierFrom == null) {
                        charges_table_item = "任意申购金额";
                    } else if (item.chargeTierTo == null) {
                        charges_table_item = "申购金额 ≥ " + Math.floor(item.chargeTierFrom / 10000) + "万元";
                    } else if (item.chargeTierFrom == 0) {
                        charges_table_item = "申购金额 < " + Math.floor(item.chargeTierTo / 10000) + "万元";
                    } else {
                        let chargeTierFrom = Math.floor(item.chargeTierFrom / 10000);
                        let chargeTierTo = Math.floor(item.chargeTierTo / 10000);
                        if (chargeTierFrom == 0) {
                            charges_table_item = "申购金额 < " + chargeTierTo + "万元";
                        } else {
                            charges_table_item = chargeTierFrom + "万元 ≤ 申购金额 < " + chargeTierTo + "万元";
                        }
                    }

                    if (item.chargeTierTo == null) {
                        $(".purchasingRate .charge-rate")
                            .eq(pensionLength)
                            .html("每笔" + this.milliFormat(item.chargeRatio) + "元");
                    } else {
                        $(".purchasingRate .charge-rate")
                            .eq(pensionLength)
                            .html(this.formatFeesValue(item.chargeRatio) + "%");
                    }
                    $(".purchasingRate .charges-table-item").eq(pensionLength).html(charges_table_item);
                }
            }

            $(".purchasingRate .pension-item").empty().append(this.renderPensionHeader("通过直销中心申购的养老金客户"));
            $(".purchasingRate").removeClass("invisible");
        } else {
            $(".purchasingRate").remove();
        }
    }

    async renderRedemptionRate(feesData) {
        if (feesData.redemptionRate != null) {
            let charges_table_item = "";
            let item = null;
            let redemptionRateShow = false;
            if (feesData.redemptionRate.length == 1 && feesData.redemptionRate[0].chargeRatio == 0) {
                const feesDescription = feesData.redemptionRate[0].description
                    ? feesData.redemptionRate[0].description
                    : "";
                this.renderFeesDescription(feesDescription);
                $(".redemptionRate").remove();
            } else {
                for (let i = 0; i < feesData.redemptionRate.length; i++) {
                    item = feesData.redemptionRate[i];

                    if (i < feesData.redemptionRate.length - 1) {
                        $(".redemptionRate .t-item").last().clone().appendTo(".redemptionRate .table-wrapper");
                    }
                    if (item.chargeTierTo == null) {
                        charges_table_item = "持有天数 ≥ " + item.chargeTierFrom + "天";
                    } else {
                        charges_table_item = item.chargeTierFrom + "天 ≤ 持有天数 < " + item.chargeTierTo + "天";
                    }
                    $(".redemptionRate .charge-rate")
                        .eq(i)
                        .html(this.formatFeesValue(item.chargeRatio) + "%");
                    $(".redemptionRate .charges-table-item").eq(i).html(charges_table_item);
                    redemptionRateShow = true;
                }
            }
            const isfof = await CAMCFundFOFHandler.getIsFOF();
            if (isfof) {
                this.renderFeesDescription("<p><b>注：具体相关费率以招募说明书为准<p><b>");
            }
            if (redemptionRateShow) {
                $(".redemptionRate").removeClass("invisible");
            }
        } else {
            $(".redemptionRate").remove();
        }
    }

    renderManageFee(feesData) {
        if (feesData.manageFee != null || feesData.custodianFee != null) {
            // let is_first_table = true;
            if (feesData.manageFee != null) {
                $(".otherRates .charge-rate")
                    .eq(0)
                    .html(this.formatFeesValue(feesData.manageFee) + "%");
                $(".otherRates .charges-table-item").eq(0).html("管理费");
            }

            if (feesData.custodianFee != null) {
                $(".otherRates .charge-rate")
                    .eq(1)
                    .html(this.formatFeesValue(feesData.custodianFee) + "%");
                $(".otherRates .charges-table-item").eq(1).html("托管费");
            }

            if (feesData.salesChargePer != null) {
                $(".otherRates .charge-rate")
                    .eq(2)
                    .html(this.formatFeesValue(feesData.salesChargePer) + "%");
                $(".otherRates .charges-table-item").eq(2).html("销售服务费");
            }

            let otherRateItems = $(".otherRates .charges-table-item");

            $.each(otherRateItems, function (index, element) {
                if (element.innerHTML == "-") {
                    $(element).parent().remove();
                }
            });

            $(".otherRates").removeClass("invisible");
        } else {
            $(".otherRates").remove();
        }
    }

    renderMRFFees(feesData) {
        const renderFeeItem = ($element, data, rateField, descField) => {
            if (data?.[descField]) {
                $element.html(data[descField]);
            } else if (data?.[rateField] !== undefined && data[rateField] !== null) {
                if (data[rateField] === 0) {
                    $element.html("0");
                } else {
                    $element.html(`${this.formatFeesValue(data[rateField])}%`);
                }
            } else {
                $element.html("暂无数据显示");
            }
        };

        const renderArrayFeeItem = ($element, dataArray) => {
            const firstItem = dataArray?.[0];
            if (firstItem?.description) {
                $element.html(firstItem.description);
            } else if (firstItem?.chargeRatio !== undefined && firstItem.chargeRatio !== null) {
                if (firstItem.chargeRatio === 0) {
                    $element.html("0");
                } else {
                    $element.html(`${this.formatFeesValue(firstItem.chargeRatio)}%`);
                }
            } else {
                $element.html("暂无数据显示");
            }
        };

        const $feesItems = this.$root.find(".fund-fees__item");

        renderArrayFeeItem(
            $feesItems.filter("#purchasingRate").find(".fund-fees__item-content"),
            feesData.purchasingRate,
        );

        renderArrayFeeItem($feesItems.filter("#switchRate").find(".fund-fees__item-content"), feesData.switchRate);

        renderArrayFeeItem(
            $feesItems.filter("#redemptionRate").find(".fund-fees__item-content"),
            feesData.redemptionRate,
        );

        renderFeeItem(
            $feesItems.filter("#manageFee").find(".fund-fees__item-content"),
            feesData,
            "manageFee",
            "manageFeeDesc",
        );

        renderFeeItem(
            $feesItems.filter("#trusteeFee").find(".fund-fees__item-content"),
            feesData,
            "trusteeFee",
            "trusteeFeeDesc",
        );

        renderFeeItem(
            $feesItems.filter("#rewardFee").find(".fund-fees__item-content"),
            feesData,
            "rewardFee",
            "rewardFeeDesc",
        );
    }
}

$(document).ready(() => {
    if (window.fundCode) {
        const websiteFundFees = new WebsiteCAMCFundFee(window.fundCode);
        websiteFundFees.render();
    }
});

export default WebsiteCAMCFundFee;
